import React from 'react'
import { useFormContext } from 'react-hook-form';
import { Dropzone, FileItem, FileValidated } from '@dropzone-ui/react'

interface PropTypes {
  updateFiles: (incomingFiles: FileValidated[]) => void, 
  onDelete: (fileId: string | number | undefined) => void, 
  formValue: string
}

//Este componente es el dropzone para subir archivos
//A este componente se le pasan dos funciones, una para actualizar los archivos que se vayan a enviar y otra para cuando se borre un archivo de la lista
const PdfDropZone = ({updateFiles, onDelete, formValue}: PropTypes ) => {
  const {formState, getValues} = useFormContext();
  const {errors} = formState;

  return (
    <>
      {/* Dropzone para carga de los archivos del usuario */}
      <Dropzone 
        onChange={updateFiles} 
        value={[...getValues(formValue)]}
        accept=".pdf"
        header={false}
        footer={false}
        behaviour="replace"
        maxFileSize={10485760}
        maxHeight={"200px"}
        minHeight={"200px"}
        >
          {getValues(formValue).map((file: FileValidated) => (
            <FileItem key={file.id} {...file} preview onDelete={onDelete} />
          ))}
          {[...getValues(formValue)].length === 0 && <p className='drop-files-text text-lg w-3/6 mt-2 pb-2 hyperlink__text'>Da click o arrastra tus archivos en formato pdf (Máximo hasta 10MB)</p>}
      </Dropzone>

      {/* Manejador de errores */}
      {errors && <p className='error-message'>{errors[formValue]?.message?.toString()}</p>}  
    </>
  )
}

export {PdfDropZone}